
import { User } from '@/types/userRole';

// Store user session data in localStorage
export const storeUserSession = (user: User): void => {
  localStorage.setItem('authUser', JSON.stringify(user));
  localStorage.setItem('isAuthenticated', 'true');
  localStorage.setItem('userRole', user.role || 'user');
  
  // Store referral code if it exists
  if (user.referralCode) {
    localStorage.setItem('userReferralCode', user.referralCode);
  }
};

// Clear all user session data from localStorage
export const clearUserSession = (): void => {
  console.log("Clearing all user session data");
  
  // Main auth items
  localStorage.removeItem('authUser');
  localStorage.removeItem('isAuthenticated');
  localStorage.removeItem('userRole');
  localStorage.removeItem('isAdmin');
  localStorage.removeItem('isSuperAdmin');
  localStorage.removeItem('isMasterAdmin');
  
  // Additional keys that might be set
  const authKeys = [
    'userId', 'userEmail', 'token', 'refreshToken', 'jwtToken',
    'user_first_login_completed', 'lastLoginTime', 'authRedirectUrl',
    'currentPlan', 'hasActiveSubscription', 'businessId', 'userReferralCode'
  ];
  
  authKeys.forEach(key => {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      console.error(`Error removing ${key} from localStorage:`, e);
    }
  });
  
  console.log("Session data clearing complete");
};

// Get user data from localStorage
export const getUserFromStorage = (): User | null => {
  const storedUser = localStorage.getItem('authUser');
  if (storedUser) {
    try {
      return JSON.parse(storedUser);
    } catch (e) {
      console.error('Error parsing stored user:', e);
      // If there's an error parsing, clear the invalid data
      clearUserSession();
    }
  }
  
  return null;
};

// Set role-specific flags in localStorage for faster access
export const setUserRoleFlags = (user: User): void => {
  if (user.isAdmin) {
    localStorage.setItem('isAdmin', 'true');
  }
  if (user.isSuperAdmin) {
    localStorage.setItem('isSuperAdmin', 'true');
  }
  if (user.isMasterAdmin) {
    localStorage.setItem('isMasterAdmin', 'true');
  }
};

// Get user's referral code from storage
export const getUserReferralCode = (): string | null => {
  return localStorage.getItem('userReferralCode');
};
